import { formatNumberValue, type NumberNotation } from './number.core'

/** Formats a non-monetary decimal or percentage. Use `formatMoney` for monetary UI. */
export const formatNumber = (
  value: number,
  notation: NumberNotation = 'standard',
  style: 'decimal' | 'percent' = 'decimal',
  maximumFractionDigits = 1,
  locale: Intl.LocalesArgument = 'en-GB',
): string => {
  return formatNumberValue(value, notation, style, maximumFractionDigits, locale)
}
